import { FiAlertCircle } from "react-icons/fi";

export default function AlertMessage({ message, style }) {
  return(
    <div className={`flex items-center bg-grey-900 border border-grey my-1 mx-2 p-2 text-sm rounded ${style}`}>
      <FiAlertCircle className="mx-1" />
      {message}
    </div>
  )
}